module.exports = __webpack_public_path__ + "img/account_creation.d7b27a43.png";